/*
 * @Author: wangcq01
 * @LastEditors: wangcq01
 * @Date: 2020-04-17 16:39:07
 * @LastEditTime: 2020-04-17 16:52:03
 * @FilePath: \dmp-web-v2\src\helpers\isIphone.js
 * @Description: 模块
 */
const isIphone = function () {
  const ua = navigator.userAgent.toLowerCase()
  if (ua.match(/iPhone/i)) {
    return true
  }
  return false
}

export default isIphone
